export { default } from './PreviewPagePane';
